<template>
  <div>
    <vue-headful :title="getPageTitle" description="Description goes here" />
    <div class="homework-review-section base-type-layout">
      <!-- FIRST ROW -->
      <div class="container mb-3">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-start align-items-center">
              <div class="avatar">
                <span
                  class="icon-caret-left flex-center brand_primary mr-3"
                ></span>
              </div>
              <router-link
                :to="'/' + account_type + '/homework/' + getSelectedChildID"
                class="go-back-link color_text font-weight-bold text-uppercase"
                >All Schoolworks</router-link
              >
            </div>
          </div>
        </div>
      </div>

      <!-- SECOND ROW -->
      <div class="container mb-4">
        <div class="row">
          <div class="col-12">
            <div class="page-title font-weight-bold color_text text-capitalize">
              {{ assessment_title ? assessment_title : "Assessment Title" }}
            </div>
          </div>
        </div>
      </div>

      <!-- THIRD ROW -->
      <div class="container">
        <div class="row">
          <div
            class="col-12 col-md-3 left-layout"
            :class="{ 'blur-out': !see_answer }"
          >
            <div class="homework-score-card white rounded-10 mb-4">
              <!-- PERFORMANCE CHART COMPONENT -->
              <PerformanceChart
                :average_score="roundUpSore"
                :switch_color="true"
                chart_title="You Scored"
                :see_score="see_answer"
              ></PerformanceChart>
              <!-- PERFORMANCE CHART COMPONENT -->

              <!-- SCORE STATS -->
              <div class="score-stats">
                <div class="first-col text-center">
                  <div
                    class="count color_text font-weight-bold"
                    :class="{ 'blur-text': !see_answer }"
                  >
                    {{ stats.correct }}
                  </div>
                  <div
                    class="count-title text-uppercase color_grey_dark font-12"
                  >
                    Correct
                  </div>
                </div>

                <div class="second-col text-center">
                  <div
                    class="count color_text font-weight-bold"
                    :class="{ 'blur-text': !see_answer }"
                  >
                    {{ stats.failed }}
                  </div>
                  <div
                    class="count-title text-uppercase color_grey_dark font-12"
                  >
                    Incorrect
                  </div>
                </div>

                <div class="third-col text-center">
                  <div
                    class="count color_text font-weight-bold"
                    :class="{ 'blur-text': !see_answer }"
                  >
                    {{ stats.skipped }}
                  </div>
                  <div
                    class="count-title text-uppercase color_grey_dark font-12"
                  >
                    Unattempted
                  </div>
                </div>
              </div>
              <!-- SCORE STATS -->

              <div class="d-flex justify-content-center w-100">
                <router-link
                  :to="'/' + account_type + '/homework/' + getSelectedChildID"
                  class="btn btn-md brand_primary_bg font-weight-bold font-11 py-3 brand_inverse_light"
                  >Take another Homework</router-link
                >
              </div>
            </div>
          </div>

          <div class="col-12 col-md-9 right-layout">
            <!-- RECOMMENDATION SECTION -->

            <!-- IF IT'S EXMA DON'T SHOW RECOMMENDATION -->

            <!--
            <div class="recommendation-section">
              <div class="title font-weight-bold color_text">Recommended for you</div>

              <div class="row">
                <div class="col-6 col-md-3 mb-3">
                  <RecommendCard
                    theme="light"
                    card_type="practice"
                    card_img="CardFour.png"
                    card_title="practice"
                    card_topic="Number Operations"
                    :show_lock="true"
                    :show_button="true"
                  ></RecommendCard>
                </div>

                <div class="col-6 col-md-3 mb-3">
                  <RecommendCard
                    theme="light"
                    card_type="video"
                    card_img="CardFive.png"
                    card_title="video lesson"
                    card_topic="Number bases"
                    :show_lock="true"
                    :show_button="true"
                  ></RecommendCard>
                </div>

                <div class="col-6 col-md-3 mb-3">
                  <RecommendCard
                    theme="light"
                    card_type="practice"
                    card_img="CardThree.png"
                    card_title="practice"
                    card_topic="Set theory"
                    :show_lock="true"
                    :show_button="true"
                  ></RecommendCard>
                </div>

                <div class="col-6 col-md-3 mb-3">
                  <RecommendCard
                    theme="light"
                    card_type="tutor"
                    card_img="TeacherOneLg.png"
                    card_title="tutoring"
                    card_topic="Algebra Sessions"
                    :show_lock="true"
                    :show_button="true"
                  ></RecommendCard>
                </div>
              </div>
            </div>-->

            <!-- REVIEW SECTION -->
            <div class="review-section">
              <div class="title font-weight-bold color_text">
                Review Questions
              </div>

              <template v-if="isFetching" name="fade" mode="out-in">
                <div class="pt-5"></div>
                <div
                  class="loader d-flex justify-content-center align-items-center my-5 border_grey_dark"
                >
                  <div
                    class="icon-dotted-roller font-27 mr-2 animate row"
                  ></div>
                  <div class="font-16">Fetching ...</div>
                </div>
              </template>

              <!-- QUESTION CARD -->
              <QuestionCard
                v-else
                question_theme="light"
                :question_id="index + 1"
                :question_text="question.text"
                :question_answer="question.answer"
                :question_choice="question.selected"
                :question_status="question.status"
                :question_image="question.image"
                :index="index + 1"
                v-for="(question, index) in questions"
                :key="index"
                :see_answer="see_answer"
              ></QuestionCard>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { capitalizeFirstLetter } from "@/scripts/utilities";
import PerformanceChart from "@/components/profileComps/studentprofile/PerformanceChart";

export default {
  name: "HomeworkReview",

  components: {
    PerformanceChart,
    // RecommendCard: () =>import(/* webpackChunkName: "RecommendCard" */ "@/components/classComps/catchup/RecommendCard"),
    QuestionCard: () =>
      import(
        /* webpackChunkName: "QuestionCard" */ "@/components/classComps/homework/QuestionCard"
      ),
  },

  computed: {
    ...mapGetters(["getSelectedChildID"]),

    getPageTitle() {
      return `Assessment Review | ${capitalizeFirstLetter(this.account_type)}`;
    },

    roundUpSore() {
      return Math.round(this.stats.score);
    },
  },

  data() {
    return {
      account_type: "",
      back_link: "",
      isFetching: true,
      assessment_title: "Assessment Title",
      see_answer: false,
      stats: {
        score: 0,
        correct: 0,
        failed: 0,
        skipped: 0,
      },
      practice_id: 0,
      child_id: null,
      questions: [],
    };
  },

  created() {
    this.getAccountType();
  },

  mounted() {
    this.practice_id = this.$route.query.id;
    if (this.account_type === "parent") this.child_id = this.$route.params.id;
    else this.child_id = null;
    this.fetchAssessmentDetails();
  },

  methods: {
    ...mapActions(["getPracticeResults"]),

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
      if (this.account_type === "parent") this.back_link = "ParentHomework";
      else if (this.account_type === "student")
        this.back_link = "StudentHomework";
    },

    // FETCH ASSESSMENT DETAILS
    fetchAssessmentDetails() {
      this.isFetching = true;
      if (this.$route.query.id) {
        // GET REPORT
        let data = {
          practice_id: this.practice_id,
          child_id: this.child_id,
        };

        this.getPracticeResults(data)
          .then((response) => {
            this.isFetching = false;
            if (response.code === 200) {
              let { data } = response;

              // console.log("Review", data);

              // thia.assessment_title;
              this.see_answer = data.can_see_answer;
              this.stats.score = data.actualScore;
              this.stats.correct = data.correct;
              this.stats.failed = data.failed;
              this.stats.skipped = data.skipped;

              this.assessment_title = data.homework_title;

              this.questions = [];

              data.questions.map((question) => {
                let question_obj = {};
                question_obj.text = question.question;
                question_obj.status = question.is_correct;
                question_obj.image = question.image;
                question_obj.status = this.getStatus(
                  question.is_correct || question.correctStatus,
                  question.selected
                );

                question_obj.options = [
                  question.option_a,
                  question.option_b,
                  question.option_c,
                  question.option_d,
                ];

                if (question.type === "multiple") {
                  question_obj.answer =
                    question_obj.options[this.convertToNumber(question.answer)];
                  question_obj.selected =
                    question_obj.options[
                      this.convertToNumber(question.selected)
                    ];
                } else if (question.type === "bool") {
                  question_obj.answer =
                    question.answer === "1" ? "True" : "False";
                  question_obj.selected =
                    question.selected === "1" || question.selected === "A"
                      ? "True"
                      : "False";
                } else if (question.type === "short") {
                  if (
                    Array.isArray(question.answer) ||
                    question.answer.includes("[", "]")
                  ) {
                    if (question_obj.status === "correct") {
                      question_obj.answer = question.selected;
                    } else question_obj.answer = JSON.parse(question.answer)[0];
                  } else {
                    question_obj.answer = question.answer;
                  }
                  question_obj.selected = question.selected;
                }

                this.questions.push(question_obj);
              });
            } else
              this.$router.push({
                name: this.back_link,
                params: { id: this.getSelectedChildID },
              });
          })
          .catch((err) => {
            this.isFetching = false;
            console.log(err);
          });
      } else
        this.$router.push({
          name: this.back_link,
          params: { id: this.getSelectedChildID },
        });
    },

    // getSelectionsInValues(list, data) {},

    convertToNumber(val) {
      if (val) {
        if (val.toLowerCase() === "a") return 0;
        else if (val.toLowerCase() === "b") return 1;
        else if (val.toLowerCase() === "c") return 2;
        else if (val.toLowerCase() === "d") return 3;
      } else {
        return false;
      }
    },

    getStatus(status, selected) {
      // console.log(status, selected);

      if (selected) {
        if (status === "1") return "correct";
        else if (status === "0") return "incorrect";
      } else return "skipped";
    },
  },
};
</script>

<style lang="scss">
.homework-review-section {
  position: relative;
  top: 110px;

  .go-back-link {
    font-size: 14px;

    &:hover {
      color: darken($brand_accent, 7%) !important;
    }

    @include breakpoint_max(sm) {
      font-size: 13px;
    }
  }

  .page-title {
    font-size: 28px;
    line-height: 44px;

    @include breakpoint_max(sm) {
      font-size: 20px;
    }
  }

  .left-layout {
    position: relative;
    min-width: 30%;
  }

  .blur-out {
    filter: blur(0.4px);
  }

  .blur-text {
    filter: blur(8px);
  }

  .right-layout {
    min-width: 70%;
    max-width: 70%;

    @include breakpoint_max(md) {
      min-width: 100%;
      max-width: 100%;
    }
  }

  .homework-score-card {
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
    padding: 48px 30px 30px;

    @include breakpoint_min_max(992, 1200) {
      padding: 40px 20px 30px;
    }

    @include breakpoint_min_max(768, 991) {
      padding: 40px 8px 30px;
    }

    .score-stats {
      margin: 35px auto;
      @include flex_row_between_wrap;

      .count {
        font-size: 19px;
        line-height: 140%;
        letter-spacing: 0.05em;
      }

      .count-title {
        font-size: 12px;
        line-height: 177.06%;
      }
    }
  }

  .recommendation-section {
    margin-bottom: 35px;

    .title {
      font-size: 21px;
      line-height: 29px;
      margin-bottom: 20px;

      @include breakpoint_max(sm) {
        font-size: 19px;
      }
    }
  }

  .review-section {
    margin-bottom: 90px;

    .title {
      font-size: 21px;
      line-height: 29px;
      margin-bottom: 20px;

      @include breakpoint_max(sm) {
        font-size: 19px;
      }
    }
  }
}
</style>
